'use strict';

var _tslib = require('../../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var react = require('react');

/**
 * @param {Object} props
 * @param {ReactNode} props.children - 박스 내부에 렌더링할 컨텐츠
 * @param {ElementType} [props.as='div'] - 렌더링할 HTML 요소
 * @param {string} [props.className] - 추가적인 CSS 클래스
 */ const Box = react.forwardRef((_a, ref)=>{
    var { className, children, as: Component = 'div' } = _a, rest = _tslib.__rest(_a, [
        "className",
        "children",
        "as"
    ]);
    return jsxRuntime.jsx(Component, Object.assign({
        ref: ref,
        className: tailwindMerge.twMerge('box-border', className)
    }, rest, {
        children: children
    }));
});
Box.displayName = 'Box';

module.exports = Box;
